import React, { useState } from 'react';
import styled from 'styled-components';
import FocusTrap from 'focus-trap-react';
import { Box } from './Box';
import { Container } from './Container';
import { Logo } from './Logo';
import { NavMenu } from './NavMenu';

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <FocusTrap
      active={isMenuOpen}
      focusTrapOptions={{ initialFocus: '#nav-menu-button' }}
    >
      <StyledHeader>
        <Container fluid>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            height="4rem"
          >
            <Logo />
            <MenuButton
              id="nav-menu-button"
              aria-haspopup="true"
              aria-controls="nav-menu"
              aria-expanded={isMenuOpen}
              onClick={() => setIsMenuOpen((prev) => !prev)}
              isMenuOpen={isMenuOpen}
            >
              {isMenuOpen ? 'Close' : 'Menu'}
            </MenuButton>
          </Box>
          {isMenuOpen && (
            <NavMenu onMenuItemClick={() => setIsMenuOpen(false)} />
          )}
        </Container>
      </StyledHeader>
    </FocusTrap>
  );
}

const StyledHeader = styled.header`
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10;
  background-color: #b5493be0;
  backdrop-filter: blur(10px);
  color: var(--white);
  text-transform: uppercase;
  font-size: 1.25rem;
  letter-spacing: var(--display-spacing-sm);
`;

const MenuButton = styled.button<{ isMenuOpen: boolean }>`
  display: contents;
  text-transform: inherit;
  font-weight: 700;
  border: none;
  background: none;
  color: var(--dark-brown);
  cursor: pointer;
  font-size: inherit;
  font-family: var(--display-font-stack);
  letter-spacing: inherit;
  padding: 0;
  &.focus-visible {
    outline: 5px solid blue;
  }
`;
